import * as m from "mithril";

export default function LiveButton(): m.Component<{
    class:string, 
    label:string, 
    isBusy?:boolean,
    busyLabel?:string,
    onClick: () => void
}> {    
    return {
        view(vnode) {
            let isBusy = vnode.attrs.isBusy;
            //console.log("Is Busy : ", isBusy)
            return m("button", {
                class: (!isBusy)? vnode.attrs.class : `${vnode.attrs.class} disabled`,
                onclick: (event) => {
                    isBusy = true;
                    vnode.attrs.onClick();
                }                
            }, (!isBusy)? 
                vnode.attrs.label : 
                [
                    m("span.spinner-border spinner-border-sm mr-2"),
                    (vnode.attrs.busyLabel)? vnode.attrs.busyLabel : vnode.attrs.label
                ]);
        }
    }
}